module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group row">\n    <label for="input-startdatalist" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (startLabel)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n    	<input type="text" required="true" class="form-control" placeholder="' +
((__t = (startPlaceHolder)) == null ? '' : __t) +
'" list="' +
((__t = (id)) == null ? '' : __t) +
'-list-startzone" id="input-startdatalist">\n    	<datalist id="' +
((__t = (id)) == null ? '' : __t) +
'-list-startzone"></datalist>\n    </div>\n    <div class="col-sm-3">\n    </div>\n    <div class="col-sm-9">\n    	<div class="row">\n    		<label id="labelStartPointLon" class="DescartesUILabel col-sm-2 col-form-label elt-ko">' +
((__t = (startPointLon)) == null ? '' : __t) +
'</label>\n    		<div class="col-sm-3">\n    			<input type="text" step="any" required="true" class="DescartesUIInput form-control-plaintext elt-ko" id="startLon" name="startLon" value="" readonly/>\n    		</div>\n    		<label id="labelStartPointLat" class="DescartesUILabel col-sm-2 col-form-label elt-ko">' +
((__t = (startPointLat)) == null ? '' : __t) +
'</label>\n    		<div class="col-sm-3">\n    			<input type="text" step="any" required="true" class="DescartesUIInput form-control-plaintext elt-ko" id="startLat" name="startLat" value="" readonly/>\n    		</div>\n    	</div>\n    </div>\n\n    <label for="input-enddatalist" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (endLabel)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n    	<input type="text" required="true" class="form-control" placeholder="' +
((__t = (endPlaceHolder)) == null ? '' : __t) +
'" list="' +
((__t = (id)) == null ? '' : __t) +
'-list-endzone" id="input-enddatalist">\n    	<datalist id="' +
((__t = (id)) == null ? '' : __t) +
'-list-endzone"></datalist>\n    </div>\n    <div class="col-sm-3">\n    </div>\n     <div class="col-sm-9">\n    	<div class="row">\n		    <label  id="labelEndPointLon" class="DescartesUILabel col-sm-2 col-form-label elt-ko">' +
((__t = (endPointLon)) == null ? '' : __t) +
'</label>\n		    <div class="col-sm-3">\n		    	<input type="text" step="any" required="true" class="DescartesUIInput form-control-plaintext elt-ko" id="endLon" name="endLon" value="" readonly/>\n		    </div>\n		    <label id="labelEndPointLat" class="DescartesUILabel col-sm-2 col-form-label elt-ko">' +
((__t = (endPointLat)) == null ? '' : __t) +
'</label>\n		    <div class="col-sm-3">\n		    	<input type="text" step="any" required="true" class="DescartesUIInput form-control-plaintext elt-ko" id="endLat" name="endLat" value="" readonly/>\n		    </div>\n        </div>\n    </div>\n\n    <label class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (modeTransportInput)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n        <select name="modeTransport" id="modeTransport" class="DescartesUISelect form-control">\n            ';
_.each(modeTransportList,function(modeTransport){;
__p += '\n            <option value="' +
((__t = (modeTransport.value)) == null ? '' : __t) +
'">' +
((__t = (modeTransport.text)) == null ? '' : __t) +
'</option>\n            ';
});;
__p += '\n        </select>\n    </div>\n    <label class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (modeCalculInput)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n        <select name="modeCalcul" id="modeCalcul" class="DescartesUISelect form-control">\n            ';
_.each(modeCalculList,function(modeCalcul){;
__p += '\n            <option value="' +
((__t = (modeCalcul.value)) == null ? '' : __t) +
'">' +
((__t = (modeCalcul.text)) == null ? '' : __t) +
'</option>\n            ';
});;
__p += '\n        </select>\n    </div>\n    <label class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (excludeInput)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n    <input type="checkbox" class="select" id="notoll" name="notoll"/> ' +
((__t = (tollText)) == null ? '' : __t) +
'\n    </br><input type="checkbox" class="select" id="nobridge" name="nobridge"/> ' +
((__t = (bridgeText)) == null ? '' : __t) +
'\n    </br><input type="checkbox" class="select" id="notunnel" name="notunnel"/> ' +
((__t = (tunnelText)) == null ? '' : __t) +
'\n    </div>\n</div>\n<button id="runAction" name="runAction" type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'">\n' +
((__t = (runActionButtonText)) == null ? '' : __t) +
'\n</button>\n<button id="runAction" name="eraseAction" type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'">\n' +
((__t = (eraseActionButtonText)) == null ? '' : __t) +
'\n</button>\n</br>\n</br>\n<div id="runActionWait" class="alert alert-info" style="display:none">' +
((__t = (waitMessage)) == null ? '' : __t) +
'</div>\n<div id="runActionError" class="alert alert-danger" style="display:none"></div>\n<div id="runActionResult" class="alert alert-success DescartesUIListResultats" style="display:none"></div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DGeoPlateforme/UI/bootstrap4/templates/GeoPlateformeRoute.ejs
// module id = 22
// module chunks = 0